import { IEntityMetaData, IPropretyAttribute } from "../../../_models/IEntityMetaData";
import { PropretyAttributes, NestedProperty, Validation } from "../../../decorators/EntityDecorators";
import { i18nLanguage } from "../i18nLanguage.model";
import { GenericEntityBase } from "../../../_models/GenericEntityBase";
import { RegexType } from "../../../services/RegexPatternLibrary";

export const TranslationRelationType = {
    //Buzzer: 'BUZZER',
    BuzzerTitle: 'BUZZERTITLE',
    BuzzerBody: 'BUZZERBODY',
    Covid: 'COVID',
    Engagement: 'ENGAGEMENT',
    Event: 'Event',
    Quiz: 'QUIZ',
    QuizResponse: 'QUIZRESPONSE',
    FireAlert: 'FIREALERT'
} as const;

export type TranslationRelationTypeValue = typeof TranslationRelationType[keyof typeof TranslationRelationType];

export class Translation extends GenericEntityBase<string> {
    private _compositeId?: string = undefined;
    // override get id(): string {
    //     if (this._compositeId == null) {
    //         this._compositeId = `${this.id}-${this.fK_Language}-${this.typeDeTraduction}`;
    //     }
    //     return this._compositeId;
    // }

    override _isRelationEntity = true;

    /** Concaténation: "{RELATION_TYPE}_{parentId}" ex: "QUIZ_42" */
    @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.KeyProperty] })
    id!: string;

    /** Même valeur que `id`, sous le nom attendu par l'API (colonne "Id" cote base).
     *  A la création, envoyer un id parent à 0 : le serveur le remplace par le vrai. */
    compoosed_Id?: string;

    @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.KeyProperty] })
    fK_Language!: number;

    @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.KeyProperty] })
    typeDeTraduction!: number;

    @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
    @Validation({
        propertyType: RegexType.StartsWithCapital,               //    Avec Auto-completion !!!
        minLength: 2,
        //pattern: '^[A-Za-z][A-Za-z0-9 @#\$%&\*\-_\+\./\?!]{2,49}$',
    })
    translationValue!: string;

    @NestedProperty({ TargetType: i18nLanguage })
    language?: i18nLanguage;

    GetType(): IEntityMetaData {
        return Translation.getMetaData();
    }

    /** Helper: Créer l'Id depuis le type de relation et l'ID parent */
    static buildId(relationType: TranslationRelationTypeValue, parentId: number): string {
        return `${relationType}_${parentId}`;
    }

    /** Helper: Parser l'Id pour extraire le type de relation et l'ID parent */
    static parseId(id: string): { relationType: string; parentId: number } {
        const [relationType, parentIdStr] = id.split('_', 2);
        return { relationType, parentId: parseInt(parentIdStr, 10) };
    }
}
